// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__eN9ww","blog__link":"styles_blog__link__jvn+l","item":"styles_item__t37jQ","item__in":"styles_item__in__RAa9G"};